import type { TranslationKey } from "@/src/i18n";
import type { StampAssetId } from "@/src/types/map";

export interface StampDefinition {
  id: StampAssetId;
  /** Dictionary key; resolve with t() at render time so it follows the language. */
  labelKey: TranslationKey;
  category: "Architecture" | "Furniture" | "Props" | "Tokens" | "Annotations";
  widthCells: number;
  heightCells: number;
}

/**
 * The fallback definition, named so the catalogue lookup has a provably defined
 * result. Reading STAMP_CATALOG[0] cannot prove that to the type checker, and
 * asserting it would only hide a real "someone emptied the catalogue" bug.
 */
const DOOR: StampDefinition = {
  id: "door", labelKey: "stamp.door", category: "Architecture", widthCells: 1, heightCells: 0.35,
};

export const STAMP_CATALOG: StampDefinition[] = [
  DOOR,
  { id: "portal", labelKey: "stamp.portal", category: "Architecture", widthCells: 1, heightCells: 1 },
  { id: "stairs", labelKey: "stamp.stairs", category: "Architecture", widthCells: 2, heightCells: 1 },
  { id: "table", labelKey: "stamp.table", category: "Furniture", widthCells: 2, heightCells: 1 },
  { id: "bed", labelKey: "stamp.bed", category: "Furniture", widthCells: 1, heightCells: 2 },
  { id: "rug", labelKey: "stamp.rug", category: "Furniture", widthCells: 2, heightCells: 1 },
  { id: "crate", labelKey: "stamp.crate", category: "Props", widthCells: 1, heightCells: 1 },
  // The marker & furniture family: one tile, then a type picker (Slice 3).
  { id: "marker", labelKey: "stamp.marker", category: "Props", widthCells: 0.7, heightCells: 0.7 },
  { id: "token_player", labelKey: "stamp.token_player", category: "Tokens", widthCells: 0.8, heightCells: 0.8 },
  { id: "token_enemy", labelKey: "stamp.token_enemy", category: "Tokens", widthCells: 0.8, heightCells: 0.8 },
  { id: "token_npc", labelKey: "stamp.token_npc", category: "Tokens", widthCells: 0.8, heightCells: 0.8 },
  { id: "text_label", labelKey: "stamp.text_label", category: "Annotations", widthCells: 2, heightCells: 0.7 },
  { id: "room_number", labelKey: "stamp.room_number", category: "Annotations", widthCells: 0.72, heightCells: 0.72 },
];

export const getStampDefinition = (assetId: StampAssetId): StampDefinition =>
  STAMP_CATALOG.find((asset) => asset.id === assetId) ??
  DOOR;
